import {
  PitcherSingleSessionReportChartConfigDto,
  PitcherSessionStatsByPitchTypeChartDto,
  TableChartConfigDto,
} from 'types/CodegenReportTypes';

import { ChartConfigProps } from 'utilities/chartIdToComponent';
import TableChartSidebar from 'components/Table/TableChartSidebar';

const disabledVisibleStats: (keyof PitcherSessionStatsByPitchTypeChartDto)[] = ['pitchType'];

const PitcherSingleSessionStatsByPitchChartSidebar = (
  props: ChartConfigProps<TableChartConfigDto, PitcherSingleSessionReportChartConfigDto>
) => {
  return (
    <TableChartSidebar
      chartId='PitcherSingleSessionStatsByPitchChart'
      chartKey='pitcherSingleSessionStatsByPitchChartConfig'
      disabledVisibleStats={disabledVisibleStats}
      {...props}
    />
  );
};

export default PitcherSingleSessionStatsByPitchChartSidebar;
